import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faTrash, faChevronDown, faChevronUp, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Msg200or201, Msg204 } from '../Messages/Messages';
import { decryptData } from '../../utils/storageCrypto';

const Assignvendor = ({
  vendor,
  categories,
  subCategoryMap,
  onLoadSubCategories,
  onClose,
  movData,
  assignProductCategoriesToSelectedVendor,
  assignedCategories,
   onAfterSave 
}) => {
  /* ---------------- STATES ---------------- */
  const [step, setStep] = useState("ASSIGN"); // ASSIGN | MOV
  const [selectedCategories, setSelectedCategories] = useState({});
  const [assignedCategoryIds, setAssignedCategoryIds] = useState([]);

  const [rows, setRows] = useState({}); 
  const [subCategories, setSubCategories] = useState({}); 
  const [isSaving, setIsSaving] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState({});
  const [editedDiscounts, setEditedDiscounts] = useState({}); 
  const [confirmDelete, setConfirmDelete] = useState(null);
    const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
     const [showPopup, setShowPopup] = useState(false);
      const [popupMessage, setPopupMessage] = useState('');
      const [popupType, setPopupType] = useState('');


  /* ---------------- HANDLERS ---------------- */

useEffect(() => {
    if (movData && assignedCategories) {
      const subToCat = {};
      Object.keys(subCategoryMap).forEach(catId => {
        (subCategoryMap[catId] || []).forEach(sub => {
          subToCat[sub._id] = catId;
        });
      });

      const newRows = {};
      const newSubCategories = {};
      
      // 🟢 FIX: Securely merge state without relying on stale closures
      setSelectedCategories(prev => {
        const updated = { ...prev };
        if (Array.isArray(assignedCategories)) {
          assignedCategories.forEach(catId => {
            updated[catId] = true;
          });
        }
        return updated;
      });

      const newAssignedCategoryIds = [...assignedCategoryIds];

      if (Array.isArray(assignedCategories)) {
        assignedCategories.forEach(catId => {
          if (!newAssignedCategoryIds.includes(catId)) {
            newAssignedCategoryIds.push(catId);
          }
          if (!subCategoryMap[catId]) {
            onLoadSubCategories(catId);
          }
          newSubCategories[catId] = subCategoryMap[catId] || [];
        });
      }

      if (movData.categories) {
        movData.categories.forEach((catMov) => {
          const catId = catMov.product_category_id;

          // 🟢 FIX: Ensure we only process MOVs for actively assigned categories
          if (assignedCategories && assignedCategories.includes(catId)) {
              if (!newAssignedCategoryIds.includes(catId)) {
                newAssignedCategoryIds.push(catId);
              }
              
              if (!subCategoryMap[catId]) {
                onLoadSubCategories(catId);
              }
              newSubCategories[catId] = subCategoryMap[catId] || [];

              const categoryRows = catMov.movs.map(movItem => {
                const discount = movItem.discount || 0;
                const row = {
                  _categoryMovId: catMov._id,
                  _subCategoryMovIds: [],   
                  mov: movItem.mov,
                  category_discount: discount,
                  subcategory_discounts: {},
                  applied: discount !== 0
                };

                movData.subcategories?.forEach(subMov => {
                  if (subMov.product_sub_category_id && subToCat[subMov.product_sub_category_id] === catId) {
                    const subMovItem = subMov.movs.find(m => m.mov === movItem.mov);
                    if (subMovItem) {
                      row.subcategory_discounts[subMov.product_sub_category_id] = subMovItem.discount || 0;
                      row._subCategoryMovIds.push(subMov._id);
                    }
                  }
                });
                return row;
              });
              newRows[catId] = categoryRows;
          }
        });
      }

      setRows(newRows);
      setSubCategories(newSubCategories);
      setAssignedCategoryIds(newAssignedCategoryIds);
    }
  }, [movData, subCategoryMap, assignedCategories]);

  const handleCategorySelect = (categoryId, checked) => {
    setSelectedCategories(prev => ({
      ...prev,
      [categoryId]: checked,
    }));

    if (checked && !subCategoryMap[categoryId]) {
      onLoadSubCategories(categoryId);
    }
  };

  const handleAssignCategories = () => {
    const selectedIds = Object.keys(selectedCategories).filter(
      id => selectedCategories[id]
    );

    setAssignedCategoryIds(selectedIds);

    // FIX: Ensure subcategories are loaded/set for newly assigned categories
    setSubCategories(prev => {
      const newSubs = { ...prev };
      selectedIds.forEach(id => {
        if (!newSubs[id]) {
          newSubs[id] = subCategoryMap[id] || [];
          if (!subCategoryMap[id]) {
            onLoadSubCategories(id); // Async load
          }
        }
      });
      return newSubs;
    });

    setStep("MOV"); // move to next phase
  };

  const addRow = (categoryId) => {
    // FIX: Use current subCategories (may have updated via handleAssignCategories or async load)
    const currentSubs = subCategories[categoryId] || [];
    const newRow = {
      mov: '',
      category_discount: 0,
      subcategory_discounts: currentSubs.reduce((acc, sub) => {
        acc[sub._id] = 0; 
        return acc;
      }, {}),
      applied: false
    };
    setRows(prev => ({
      ...prev,
      [categoryId]: [...(prev[categoryId] || []), newRow]
    }));
  };

//  const deleteRow = async (categoryId, rowIndex) => {
//   const row = rows[categoryId][rowIndex];

//  if (row._categoryMovId || row._subCategoryMovIds?.length) {
//   await deleteMovFromDB({
//     category_mov_id: row._categoryMovId,
//     subcategory_mov_ids: row._subCategoryMovIds || []
//   });
// }

//   setRows(prev => ({
//     ...prev,
//     [categoryId]: prev[categoryId].filter((_, i) => i !== rowIndex)
//   }));
// };


  const handleApply = (categoryId, rowIndex) => {
    const categoryDiscount = rows[categoryId][rowIndex].category_discount;
    setRows(prev => ({
      ...prev,
      [categoryId]: prev[categoryId].map((r, i) => {
        if (i === rowIndex) {
          const newSubDiscounts = { ...r.subcategory_discounts };
          (subCategories[categoryId] || []).forEach(sub => {
            newSubDiscounts[sub._id] = categoryDiscount;
          });
          return { ...r, subcategory_discounts: newSubDiscounts, applied: true };
        }
        return r;
      })
    }));
  };

  const toggleCategoryExpand = (catId) => {
    setExpandedCategories(prev => ({
      ...prev,
      [catId]: !prev[catId],
    }));
  };

  const handleSaveChanges = async () => {
    const encryptedHubId = sessionStorage.getItem('hubId');
    const hubId = decryptData(encryptedHubId);

    setIsSaving(true);

    const vendorId = vendor?._id || vendor?.id;

    const finalSelectedCategoryIds = Object.keys(selectedCategories).filter(
  id => selectedCategories[id] === true
);

    // Combined payload to match backend expectation
    const payload = {
      vendor_id: vendorId,
     product_category_ids: finalSelectedCategoryIds,
      movData: {
        categories: [],
        subcategories: [],
      },
    };

/* -------- CATEGORY LEVEL MOVS -------- */
    Object.keys(rows).forEach(catId => {
      // Only process MOVs if the category is still checked
      if (selectedCategories[catId]) {
        rows[catId].forEach(row => {
          if (row.mov && row.category_discount !== '') {
            payload.movData.categories.push({
              product_category_id: catId,
              vendor_id: vendorId,
              hubId:hubId,
              movs: [
                {
                  mov: Number(row.mov),
                  discount: Number(row.category_discount)
                }
              ]
            });
          }
        });
      }
    });

/* -------- SUBCATEGORY LEVEL MOVS -------- */
Object.keys(rows).forEach(catId => {
  // Only process MOVs if the category is still checked
  if (selectedCategories[catId]) {
    rows[catId].forEach(row => {
      Object.entries(row.subcategory_discounts || {}).forEach(([subId, discount]) => {
        if (discount !== '' && discount !== null) {
          payload.movData.subcategories.push({
            product_sub_category_id: subId,
            vendor_id: vendorId,
            hubId:hubId,
            movs: [
              {
                mov: Number(row.mov),
                discount: Number(discount)
              }
            ]
          });
        }
      });
    });
  }
});

    /* ---------------- FINAL API CALL ---------------- */
    await assignProductCategoriesToSelectedVendor(payload);

     if (onAfterSave) {
    await onAfterSave();   
  }
    setAssignedCategoryIds(finalSelectedCategoryIds);
    setIsSaving(false);
    onClose();
  };

const deleteMovFromDB = async (payload) => {
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const deletePayload = {
      category_deletes: [],  
      subcategory_deletes: []  
    };

    if (payload.category_document_id && payload.mov !== undefined) {
      deletePayload.category_deletes.push({
        document_id: payload.category_document_id, 
        mov: Number(payload.mov)  
      });
    }

    if (payload.subcategory_deletes && Array.isArray(payload.subcategory_deletes)) {
      deletePayload.subcategory_deletes = payload.subcategory_deletes.map(item => ({
        document_id: item.document_id, 
        mov: Number(item.mov)  
      }));
    }

    const response = await fetch(
      `${backendApiUrl}movs/delete-movs`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-token": token
        },
        body: JSON.stringify(deletePayload) 
      }
    );

    if (!response.ok) {
      throw new Error(`Delete failed: ${response.statusText}`);
    }

    const data = await response.json();
    console.log("Delete MOV response", data);

     if (response.status === 200 || response.status === 201) {
      setPopupMessage(data?.message || "MOV deleted successfully");
      setPopupType("200or201");
      setShowPopup(true);
       setTimeout(() => {
    setShowPopup(false);
  }, 3000);
    } 
    else {
      throw new Error(data?.message || "Delete failed");
    }
  } catch (error) {
    console.error("Delete MOV error", error);
   
  }
};

const deleteRow = async (categoryId, rowIndex) => {
  const row = rows[categoryId][rowIndex];

  const subcategoryDeletes = (row._subCategoryMovIds || []).map(subDocId => ({
    document_id: subDocId,
    mov: Number(row.mov)
  }));

  await deleteMovFromDB({
    category_document_id: row._categoryMovId,
    mov: Number(row.mov),
    subcategory_deletes: subcategoryDeletes
  });

  // Remove from UI
  setRows(prev => ({
    ...prev,
    [categoryId]: prev[categoryId].filter((_, i) => i !== rowIndex)
  }));

  setConfirmDelete(null);
};



  /* ---------------- RENDER ---------------- */

  const visibleCategories =
    step === "ASSIGN"
      ? categories
      : categories.filter(cat => selectedCategories[cat._id])

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white rounded-lg shadow-xl flex flex-col w-[70%] h-[80%]">
        <div className="px-6 py-3 border-b relative">
          {step === "MOV" && (
            <button
              onClick={() => setStep("ASSIGN")}
              className="absolute top-4 left-6 text-gray-600 hover:text-gray-800"
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
          )}

          <button
            onClick={onClose}
            className="absolute top-4 right-6 text-red-600"
          >
            <FontAwesomeIcon icon={faX} />
          </button>

          <h2
            className={`text-lg font-semibold ${
              step === "MOV" ? "pl-8" : ""
            }`}
          >
            {step === "ASSIGN"
              ? "Assign Categories to Vendor"
              : "Set MOV for Categories"}
          </h2>

          <p
            className={`mt-1 text-sm text-gray-600 ${
              step === "MOV" ? "pl-8" : ""
            }`}
          >
            Vendor:{" "}
            <span className="text-blue-600 font-medium">
              {vendor?.name}
            </span>
          </p>
        </div>

        {/* CONTENT */}
        <div className="p-4 flex-1 overflow-y-auto space-y-4">
          <p className="text-sm text-gray-600 mb-3">
            Select the product categories this vendor can supply:
          </p>

          {visibleCategories.map(cat => {
            const categoryRows = rows[cat._id] || [];
            const subs = subCategories[cat._id] || [];
            const hasSubCategories = subs.length > 0;

            return (
              <div key={cat._id} className="border rounded-md p-3">
                {/* CATEGORY ROW */}
              <div className="flex justify-between items-center">
  <div className="flex items-center gap-2">
    {step === "ASSIGN" && (
      <input
        type="checkbox"
        checked={!!selectedCategories[cat._id]}
        onChange={(e) =>
          handleCategorySelect(cat._id, e.target.checked)
        }
      />
    )}

    <span className="font-medium">
      {cat.product_category_name}
    </span>

    {step === "MOV" && categoryRows.length > 0 && (
      <button
        onClick={() => toggleCategoryExpand(cat._id)}
        className="text-gray-600"
      >
        <FontAwesomeIcon
          icon={
            expandedCategories[cat._id]
              ? faChevronUp
              : faChevronDown
          }
        />
      </button>
    )}
  </div>

  {/* ✅ RIGHT END ASSIGNED BADGE */}
  {assignedCategoryIds.includes(cat._id) && step === "ASSIGN" && (
    <span className="text-xs font-semibold text-green-700 bg-green-100 px-2 py-0.5 rounded-full">
      Assigned
    </span>
  )}

  {step === "MOV" && (
    <button
      onClick={() => {
        addRow(cat._id);
        setExpandedCategories((prev) => ({
          ...prev,
          [cat._id]: true,
        }));
      }}
      className="text-xs bg-blue-500 px-2 py-2 rounded text-white font-medium"
    >
      Add MOV
    </button>
  )}
</div>

                {/* MOV TABLE */}
                {step === "MOV" &&
                  expandedCategories[cat._id] &&
                    categoryRows.length > 0 && ( 
                    <div className="rounded-md overflow-x-auto overflow-y-auto p-4">
                      <table className="mx-auto w-full border-collapse text-sm">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="border px-4 py-2 w-12"></th>
                            <th className="border px-4 py-2 text-center font-medium">
                              MOV
                            </th>
                            <th className="border px-3 py-2 text-center">
                              <div className="flex flex-col items-center leading-tight">
                                <span className="text-sm font-medium">
                                  Category Level
                                </span>
                                <span className="text-xs font-medium">
                                  Discount (%)
                                </span>
                              </div>
                            </th>
                            <th className="border px-3 py-2 text-center">
                              <div className="flex flex-col items-center leading-tight">
                                <span className="text-sm font-medium">
                                  SubCategory Level
                                </span>
                                <span className="text-xs font-medium">
                                  Discount (%)
                                </span>
                              </div>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {categoryRows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              <td className="border px-2 py-2 text-center">
                            <button
  onClick={() => {
    const row = rows[cat._id][rowIndex];

    const isExistingRow =
      !!row._categoryMovId ||
      (Array.isArray(row._subCategoryMovIds) &&
        row._subCategoryMovIds.length > 0);

    if (isExistingRow) {
      setConfirmDelete({ categoryId: cat._id, rowIndex });
    } else {
      setRows(prev => ({
        ...prev,
        [cat._id]: prev[cat._id].filter((_, i) => i !== rowIndex)
      }));
    }
  }}
>
  <FontAwesomeIcon icon={faTrash} />
</button>

                              </td>

                              <td className="border px-2 py-2 text-center">
                                <input
                                  className="w-20 border rounded-md px-2 py-1 text-sm text-center"
                                  value={row.mov}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setRows(prev => ({
                                      ...prev,
                                      [cat._id]: prev[cat._id].map((r, i) =>
                                        i === rowIndex ? { ...r, mov: value } : r
                                      )
                                    }));
                                  }}
                                />
                              </td>

                           <td className="border px-2 py-2 text-center">
  <div className="flex items-center justify-center gap-2">
    <input
      type="number"
      className="w-20 border rounded-md px-2 py-1 text-sm text-center"
      value={row.category_discount}
      onChange={(e) => {
        const value = e.target.value;
        setRows(prev => ({
          ...prev,
          [cat._id]: prev[cat._id].map((r, i) =>
            i === rowIndex
              ? { ...r, category_discount: value, applied: false }
              : r
          )
        }));
        setEditedDiscounts(prev => ({
          ...prev,
          [`${cat._id}-${rowIndex}`]: true,
        }));
      }}
    />

    {hasSubCategories &&
     editedDiscounts[`${cat._id}-${rowIndex}`] &&
     row.category_discount !== '' &&
     row.category_discount !== null &&
     row.category_discount !== 0 && (
      <button
        onClick={() => handleApply(cat._id, rowIndex)}
        className={`text-[10px] px-2 py-1 rounded border whitespace-nowrap ${
          row.applied
            ? "bg-gray-400 text-white"
            : "bg-green-600 text-white"
        }`}
      >
        {row.applied ? "Applied" : "Apply"}
      </button>
    )}
  </div>
</td>


                              <td className="border px-2 py-2 align-middle">
                                <div className="flex flex-col gap-3 items-center">
                                  {subs.map((sub) => (
                                    <div
                                      key={sub._id}
                                      className="grid grid-cols-[1fr_80px] items-center gap-3"
                                      style={{ minWidth: "200px" }}
                                    >
                                      <span className="text-sm break-words text-left">
                                        {sub.product_sub_category_name}
                                      </span>
                                      <input
                                        type="number"
                                        className="w-20 border rounded px-2 py-1 text-xs text-center"
                                        placeholder=" "
                                     value={
  row.subcategory_discounts?.[sub._id] !== undefined
    ? row.subcategory_discounts[sub._id]
    : ""
}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          setRows(prev => ({
                                            ...prev,
                                            [cat._id]: prev[cat._id].map((r, i) =>
                                              i === rowIndex
                                                ? {
                                                    ...r,
                                                    subcategory_discounts: {
                                                      ...r.subcategory_discounts,
                                                      [sub._id]: value === "" ? "" : Number(value)
                                                    }
                                                  }
                                                : r
                                            )
                                          }));
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
              </div>
            );
          })}
        </div>

        {/* FOOTER */}
        <div className="px-4 py-3 border-t flex justify-end gap-2">
          <button onClick={onClose} className="border px-4 py-1 rounded">
            Close
          </button>

          {step === "ASSIGN" ? (
            (() => {
              const hasAssigned = assignedCategoryIds.length > 0;
              const selectedIds = Object.keys(selectedCategories).filter(id => selectedCategories[id]);
              const hasNewSelections = selectedIds.some(id => !assignedCategoryIds.includes(id));

              if (hasAssigned && hasNewSelections) {
                return (
                  <button
                    onClick={handleAssignCategories}
                    disabled={selectedIds.length === 0}
                    className={`px-4 py-1 rounded ${
                      selectedIds.length === 0
                        ? "bg-gray-400 text-gray-600 cursor-not-allowed"
                        : "bg-blue-600 text-white"
                    }`}
                  >
                    Assign
                  </button>
                );
              } else if (hasAssigned) {
                return (
                  <button
                    onClick={() => setStep("MOV")} 
             className="bg-blue-600 text-white px-4 py-1 rounded"
          >
            Next
          </button>
        );
      } else {
        return (
          <button
            onClick={handleAssignCategories}
            disabled={selectedIds.length === 0}
            className={`px-4 py-1 rounded ${
              selectedIds.length === 0
                ? "bg-gray-400 text-gray-600 cursor-not-allowed"
                : "bg-blue-600 text-white"
            }`}
          >
            Assign
          </button>
        );
      }
    })()
  ) : (
    <button
      onClick={handleSaveChanges}
      disabled={isSaving}
      className="bg-blue-600 text-white px-4 py-1 rounded"
    >
      Save Changes
    </button>
  )}
</div>
      </div>

    {confirmDelete && (
  <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50">
    <div className="bg-white rounded-lg w-[320px] shadow-xl">

      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <h3 className="text-base font-semibold text-gray-800">
          Confirm Delete
        </h3>

        <button
          onClick={() => setConfirmDelete(null)}
          className="text-gray-600 hover:text-gray-600 text-sm"
        >
          <FontAwesomeIcon icon={faX} />
        </button>
      </div>

      {/* Body */}
      <div className="px-4 py-5 text-center">
        <p className="text-sm text-gray-600">
          Are you sure you want to delete this MOV?
        </p>
      </div>

      {/* Footer */}
      <div className="flex justify-center gap-4 px-4 py-3 border-t">
        <button
          onClick={() => setConfirmDelete(null)}
          className="px-4 py-1.5 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-100"
        >
          No
        </button>

        <button
          onClick={() =>
            deleteRow(
              confirmDelete.categoryId,
              confirmDelete.rowIndex
            )
          }
          className="px-4 py-1.5 bg-red-600 text-white rounded-md text-sm hover:bg-red-700"
        >
          Yes, Delete
        </button>
      </div>

    </div>
  </div>
)}

{showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
   </div>
)}

    </div>
  );
};

export default Assignvendor;